<div class="modal-header">
  <h5 class="w-100">
    <strong>Superamenti Reportnet3 ammessi</strong>
  </h5>
</div>

<div class="modal-body">
  <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>

  <mat-tab-group *ngIf="!loading" animationDuration="0ms">
    <mat-tab label="Tipologia punto di conformità">
      <div class="scrollable-div">
        <table mat-table [dataSource]="tipologiePuntoConformita" class="w-100">
          <ng-container matColumnDef="codice">
            <th mat-header-cell *matHeaderCellDef>Codice</th>
            <td mat-cell *matCellDef="let row">{{ row.codice }}</td>
          </ng-container>
          <ng-container matColumnDef="descrizione">
            <th mat-header-cell *matHeaderCellDef>Descrizione</th>
            <td mat-cell *matCellDef="let row">{{ row.descrizione }}</td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="columns"></tr>
          <tr mat-row *matRowDef="let row; columns: columns"></tr>
        </table>
      </div>
    </mat-tab>

    <mat-tab label="Causa superamento">
      <div class="scrollable-div">
        <table mat-table [dataSource]="causeSuperamento" class="w-100">
          <ng-container matColumnDef="codice">
            <th mat-header-cell *matHeaderCellDef>Codice</th>
            <td mat-cell *matCellDef="let row">{{ row.codice }}</td>
          </ng-container>
          <ng-container matColumnDef="descrizione">
            <th mat-header-cell *matHeaderCellDef>Descrizione</th>
            <td mat-cell *matCellDef="let row">{{ row.descrizione }}</td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="columns"></tr>
          <tr mat-row *matRowDef="let row; columns: columns"></tr>
        </table>
      </div>
    </mat-tab>

    <mat-tab label="Azione correttiva">
      <div class="scrollable-div">
        <table mat-table [dataSource]="azioniCorrettive" class="w-100">
          <ng-container matColumnDef="codice">
            <th mat-header-cell *matHeaderCellDef>Codice</th>
            <td mat-cell *matCellDef="let row">{{ row.codice }}</td>
          </ng-container>
          <ng-container matColumnDef="descrizione">
            <th mat-header-cell *matHeaderCellDef>Descrizione</th>
            <td mat-cell *matCellDef="let row">{{ row.descrizione }}</td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="columns"></tr>
          <tr mat-row *matRowDef="let row; columns: columns"></tr>
        </table>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>

<div class="d-flex justify-content-end align-items-center mt-3">
  <button mat-button (click)="close()">Chiudi</button>
</div>
